import Axios from "@/plugins/Axios";

class AberturaPreMatriculasService {
  async listar() {
    const response = await Axios().get("matriculas/abertura-prematriculas");
    return response.data;
  }

  async buscarPorAno(anoId) {
    const response = await Axios().get(`matriculas/abertura-prematriculas/ano/${anoId}`);
    return response.data;
  }

  async getAberturaAtiva() {
    const response = await Axios().get("matriculas/abertura-prematriculas/ativa");
    return response.data;
  }

  async criar(dados) {
    const response = await Axios().post("matriculas/abertura-prematriculas", dados);
    return response.data;
  }

  async atualizar(id, dados) {
    const response = await Axios().put(`matriculas/abertura-prematriculas/${id}`, dados);
    return response.data;
  }

  async excluir(id) {
    const response = await Axios().delete(`matriculas/abertura-prematriculas/${id}`);
    return response.data;
  }

  async listarAnos() {
    const response = await Axios().get("matriculas/abertura-prematriculas/anos");
    return response.data;
  }
}

export default new AberturaPreMatriculasService();
